module.exports = __webpack_public_path__ + "static/img/2.3a5967b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/3/1/eng/2.png
// module id = TRXX
// module chunks = 0